import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation, EffectFade } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

const ImageSlider = ({
  slides = [],
  variant = "auto", // auto | desktop | mobile
  height = "h-full",
  overlay = false,
  grayscale = false,
}) => {
  const DesktopSlider = () => (
    <Swiper
      modules={[Autoplay, Pagination, EffectFade, Navigation]}
      effect="fade"
      loop
      speed={1200}
      autoplay={{
        delay: 5000,
        disableOnInteraction: false,
      }}
      pagination={{
        clickable: true,
        renderBullet: (index, className) =>
          `<span class="${className} custom-bullet"></span>`,
      }}
      navigation
      className={`w-full ${height}`}
    >
      {slides.map((image, index) => (
        <SwiperSlide key={index}>
          <div className="relative w-full h-full overflow-hidden">
            <img
              src={image}
              alt=""
              className={`
                w-full h-full object-cover
                ${grayscale ? "grayscale" : ""}
                scale-105
                animate-[slowZoom_8s_linear_forwards]
              `}
            />

            {overlay && <div className="absolute inset-0 bg-black/20" />}
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );

  const MobileSlider = () => (
    <Swiper
      modules={[Autoplay, Pagination]}
      loop
      autoplay={{
        delay: 5000,
        disableOnInteraction: false,
      }}
      pagination={{
        clickable: true,
        renderBullet: (index, className) =>
          `<span class="${className} custom-bullet"></span>`,
      }}
      className={`w-full ${height}`}
    >
      {slides.map((image, index) => (
        <SwiperSlide key={index}>
          <img
            src={image}
            alt=""
            className={`
              w-full h-full object-cover
              ${grayscale ? "grayscale" : ""}
            `}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );

  if (variant === "desktop") return <DesktopSlider />;
  if (variant === "mobile") return <MobileSlider />;

  return (
    <>
      <div className="hidden lg:block">
        <DesktopSlider />
      </div>

      <div className="lg:hidden">
        <MobileSlider />
      </div>
    </>
  );
};

export default ImageSlider;
